let sw = window.innerWidth;
let sh = window.innerHeight;
let isInitialized = false;

function fontResizer() {
  const currentWidth = window.innerWidth;
  const perc = currentWidth / 120;

  if (document.body) {
    document.body.style.fontSize = `${perc}px`;
  }
}

function handleResize() {
  sw = window.innerWidth;
  sh = window.innerHeight;

  if (sw > 1025) {
    if (sw < 1400 && sw > 1300 && sh > 900) {
      return;
    }

    fontResizer();
  }
}

function LoadAndResizer() {
  if (isInitialized) return;
  isInitialized = true;

  const init = () => {
    const loader = document.querySelector(".loader-first");
    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader);
    }

    if (window.innerWidth > 1199) {
      fontResizer();
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  window.addEventListener("resize", handleResize, { passive: true });
}

export default LoadAndResizer;
